export const MonkeyMark = ({ size = 40, className = "" }) => (
  <svg
    viewBox="0 0 64 64"
    width={size}
    height={size}
    className={className}
    aria-label="KITOE monkey mascot"
  >
    <circle cx="11" cy="26" r="9" fill="#8A5A33" stroke="#1E1E24" strokeWidth="2.5" />
    <circle cx="11" cy="26" r="4.5" fill="#F2CE9B" />
    <circle cx="53" cy="26" r="9" fill="#8A5A33" stroke="#1E1E24" strokeWidth="2.5" />
    <circle cx="53" cy="26" r="4.5" fill="#F2CE9B" />
    <circle cx="32" cy="33" r="23" fill="#A06B3B" stroke="#1E1E24" strokeWidth="2.5" />
    <ellipse cx="32" cy="40" rx="15" ry="13" fill="#F2CE9B" />
    <circle cx="24.5" cy="30" r="5" fill="#FFFFFF" stroke="#1E1E24" strokeWidth="2" />
    <circle cx="39.5" cy="30" r="5" fill="#FFFFFF" stroke="#1E1E24" strokeWidth="2" />
    <circle className="monkey-pupil" cx="25.5" cy="31" r="2.4" fill="#1E1E24" />
    <circle className="monkey-pupil" cx="38.5" cy="31" r="2.4" fill="#1E1E24" />
    <ellipse cx="32" cy="39" rx="3" ry="2.2" fill="#1E1E24" />
    <path
      d="M25 44 Q32 50 39 44"
      fill="none"
      stroke="#1E1E24"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path d="M27 12 Q32 6 37 12" fill="none" stroke="#1E1E24" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ size = 40, light = false }) => (
  <span className="inline-flex items-center gap-2.5 group">
    <span className="transition-transform duration-300 group-hover:-rotate-12 group-hover:scale-110 inline-block">
      <MonkeyMark size={size} />
    </span>
    <span className="leading-none">
      <span
        className={`block font-display font-black text-2xl tracking-tight ${
          light ? "text-cream" : "text-ink"
        }`}
      >
        KITOE
      </span>
      <span
        className={`block text-[10px] font-bold uppercase tracking-[0.28em] ${
          light ? "text-cream/60" : "text-ink/50"
        }`}
      >
        entertainment
      </span>
    </span>
  </span>
);
